import moment from 'moment-timezone';
import { get } from 'lodash';

const tzLondon = 'Europe/London';

export function isToday(dateStr) {
    const today = moment().tz(tzLondon);
    const date = moment.tz(dateStr, tzLondon);
    return date.isSame(today, 'day');
}

export function isTomorrow(dateStr) {
    const tomorrow = moment().tz(tzLondon).add(1, 'days');
    const date = moment.tz(dateStr, tzLondon);
    return date.isSame(tomorrow, 'day');
}

export const sortByDate = (key, reverse = false) => (a, b) => {
    const date1 = new Date(get(a, key));
    const date2 = new Date(get(b, key));
    const reverseCoef = reverse ? -1 : 1;
    if (date1 > date2) {
        return -1 * reverseCoef;
    }
    if (date1 < date2) {
        return 1 * reverseCoef;
    }

    return 0;
};

export const sortByRecentMonth = (key, reverse = false) => (a, b) => {
    const date1 = moment(a[key], 'MMMM YYYY');
    const date2 = moment(b[key], 'MMMM YYYY');
    const reverseCoef = reverse ? -1 : 1;

    if (date1 > date2) {
        return -1 * reverseCoef;
    }
    if (date1 < date2) {
        return 1 * reverseCoef;
    }

    return 0;
};

export function formatDate(dateStr, format) {
    return dateStr ? moment.tz(dateStr, tzLondon).format(format) : '';
}

export const formatEntryDate = (dateStr, format) => {
    if (!dateStr) {
        return null;
    }

    if (isToday(dateStr)) {
        return 'Today';
    }

    if (isTomorrow(dateStr)) {
        return 'Tomorrow';
    }

    return formatDate(dateStr, format || 'dddd, DD MMMM YYYY');
};

export const formatEntryTime = dateStr =>
    formatDate(dateStr, 'h:mm');

export const formatEntryDateTime = dateStr =>
    `${formatEntryDate(dateStr)} - ${formatEntryTime(dateStr)}`;

export const getYearFromUtc = (utcStr = null) =>
    new Date(utcStr).getUTCFullYear();



// WEBPACK FOOTER //
// ./src/js/utils/date.js